import BaseComponent from '/webresources-sources/js/components/base-component';
import { TweenMax } from 'gsap';
import { defineComponent } from '/webresources-sources/js/util/jquery';

export default class StageComponent extends BaseComponent {
    connected() {
        $('html').mousemove(function (e) {
            var wx = $(window).width();
            var wy = $(window).height();

            var x = e.pageX - this.offsetLeft;
            var y = e.pageY - this.offsetTop;

            var newx = x - wx / 2;
            var newy = y - wy / 2;

            $('.parallax-element').each(function () {
                var speed = $(this).attr('data-speed');
                if ($(this).attr('data-revert')) speed *= -1;
                TweenMax.to($(this), 1, { x: 1 - newx * speed, y: 1 - newy * speed });
            });
        });

        document.addEventListener(
            'scroll',
            (event) => {
                this.element.style.setProperty('--parallax-scroll-top', `${Math.round(window.scrollY / 2)}px`);
                $('.parallax-element').each(function () {
                    var speed = $(this).attr('data-speed');
                    var scrollY = window.scrollY * 2;
                    if ($(this).attr('data-revert')) speed *= -1;
                    TweenMax.to($(this), 1, { x: 1 - scrollY * speed });
                });
            },
            {
                capture: true,
                passive: true,
            },
        );
    }
}

defineComponent('stage-component', StageComponent);
